// Components that are only used on the MyFriends tab (and related pages)
// Please keep the exports sorted to avoid merge conflicts.
import { defineAsyncComponent } from "vue";

export const FriendRequest = defineAsyncComponent(async () => (await import("./static/MyFriends")).FriendRequest);
export const MemberSearch = defineAsyncComponent(async () => (await import("./static/MyFriends")).MemberSearch);
export const MemberUnblockList = defineAsyncComponent(async () => (await import("./static/MyFriends")).MemberUnblockList);
export const MemberUnfriendList = defineAsyncComponent(async () => (await import("./static/MyFriends")).MemberUnfriendList);
export const Message = defineAsyncComponent(async () => (await import("./static/MyFriends")).Message);
